import { Radio, Typography } from "antd";
import { CheckCircle, XCircle } from "lucide-react";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Question } from "@types";
import { useTranslation } from "react-i18next";

interface Props {
  question?: Question
}

export const CorrectIncorrectOption = ({question}: Props) => {

  const [checked, setChecked] = useState<string | undefined>(undefined);
  const {t} = useTranslation();

  useEffect(() => {
    if (question && (question?.playerAnswers?.length! > 0)) {
      setChecked(question?.playerAnswers?.[0]?.value);
    }
  }, [question]);

  const isCorrect = checked === question?.answers[0]?.value;
  const showCorrectAnswer = checked !== undefined && !isCorrect;
  
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 1 }}
    >
      <Radio.Group
        value={checked}
        style={{ width: "100%", textAlign: "center" }}
      >
        <Radio value={"correct"} style={{ flexDirection: "column-reverse" }}>
          <div
            style={{ width: "120px" }}
            className={`custom-radio-btn ${
              checked === "correct"
                ? isCorrect
                  ? "custom-radio-btn-valid"
                  : "custom-radio-btn-invalid"
                : showCorrectAnswer && question?.answers[0]?.value === "correct"
                ? "custom-radio-btn-valid"
                : ""
            }`}
          >
            <CheckCircle color="green" style={{ width: 48, height: 48 }} />
            <Typography.Title level={5} style={{ margin: 0 }}>
            {t("forms.questions.correct")}
            </Typography.Title>
          </div>
        </Radio>
        <Radio value={"incorrect"} style={{ flexDirection: "column-reverse" }}>
          <div
            style={{ width: "120px" }}
            className={`custom-radio-btn ${
              checked === "incorrect"
                ? isCorrect
                  ? "custom-radio-btn-valid"
                  : "custom-radio-btn-invalid"
                : showCorrectAnswer && question?.answers[0]?.value === "incorrect"
                ? "custom-radio-btn-valid"
                : ""
            }`}
          >
            <XCircle color="red" style={{ width: 48, height: 48 }} />
            <Typography.Title level={5} style={{ margin: 0 }}>
            {t("forms.questions.incorrect")}
            </Typography.Title>
          </div>
        </Radio>
      </Radio.Group>
    </motion.div>
  );
};
